// extracted by mini-css-extract-plugin
export default {"links":"NavBar_links__qUQoI","link":"NavBar_link__vzTEJ"};